const historyPathList = [];

export const getHistoryPathList = () => historyPathList;
export const addPathToHistoryPathList = (path) => {
  if (historyPathList?.[historyPathList?.length - 1] !== path && path) {
    historyPathList.push(path);
  }

  return historyPathList;
};
